export const purple = {
  1: "#9757E9",
  2: "#B780FF",
  3: "#D7B9FF",
  4: "#EAD7FF",
};

export const green = {
  1: "#06D49E",
  2: "#00B789",
  3: "#A7ECD3",
};

export const red = {
  1: "#F0466F",
  2: "#FED3DC",
};

export const grey = {
  1: "#CFCBD6",
};

export const blue = {
  1: "#51BADE",
  2: "#95CFE3",
  3: "#D0E8F3",
};

export const orange = {
  1: "#F97242",
  2: "#FFDDD1",
};

export const white = "#FFF";

export const black = "#000";

// Utility

export const text = {
  primary: "#3F2B55",
};

export const border = {
  primary: "#2F085F58",
};

export const background = {
  primary: "#F4F2F8",
};

export const legendBackground = "#F7F7F7";

export const boxShadow = "#00000029";
